import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_66572988 from 'nuxt_plugin_sentryserver_66572988' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_009db800 from 'nuxt_plugin_sentryclient_009db800' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_593d6dc4 from 'nuxt_plugin_axios_593d6dc4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_httpserver_4d023fb1 from 'nuxt_plugin_httpserver_4d023fb1' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_f08c47e8 from 'nuxt_plugin_http_f08c47e8' // Source: ./http.js (mode: 'all')
import nuxt_plugin_stripemodule_088148e4 from 'nuxt_plugin_stripemodule_088148e4' // Source: ./stripe-module.js (mode: 'client')
import nuxt_plugin_pluginutils_7921c0f7 from 'nuxt_plugin_pluginutils_7921c0f7' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6db5ec82 from 'nuxt_plugin_pluginrouting_6db5ec82' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_23841e2d from 'nuxt_plugin_pluginmain_23841e2d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_dfaf94e0 from 'nuxt_plugin_apollomodule_dfaf94e0' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_svg4everybody_b33937ba from 'nuxt_plugin_svg4everybody_b33937ba' // Source: ./nuxt-polyfill/svg4everybody.js (mode: 'all')
import nuxt_plugin_nodelistforeachpolyfill_1ec65051 from 'nuxt_plugin_nodelistforeachpolyfill_1ec65051' // Source: ./nuxt-polyfill/nodelist-foreach-polyfill.js (mode: 'all')
import nuxt_plugin_matchMediaaddListener_24a1a5f4 from 'nuxt_plugin_matchMediaaddListener_24a1a5f4' // Source: ./nuxt-polyfill/matchmedia-polyfill/matchMedia.addListener.js (mode: 'all')
import nuxt_plugin_matchmediapolyfill_e33abb9a from 'nuxt_plugin_matchmediapolyfill_e33abb9a' // Source: ./nuxt-polyfill/matchmedia-polyfill.js (mode: 'all')
import nuxt_plugin_es7objectpolyfill_873cf992 from 'nuxt_plugin_es7objectpolyfill_873cf992' // Source: ./nuxt-polyfill/es7-object-polyfill.js (mode: 'all')
import nuxt_plugin_nuxtmq_553e0dcc from 'nuxt_plugin_nuxtmq_553e0dcc' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_zendeskChat_0986d3fe from 'nuxt_plugin_zendeskChat_0986d3fe' // Source: ../../../plugins/zendeskChat (mode: 'client')
import nuxt_plugin_featureFlags_adcaf0b2 from 'nuxt_plugin_featureFlags_adcaf0b2' // Source: ../../../plugins/featureFlags (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0' // Source: ../../../plugins/analytics (mode: 'client')
import nuxt_plugin_downloadPdf_78eb8214 from 'nuxt_plugin_downloadPdf_78eb8214' // Source: ../../../plugins/downloadPdf (mode: 'client')
import nuxt_plugin_scroll_3c47dc7a from 'nuxt_plugin_scroll_3c47dc7a' // Source: ../../../plugins/scroll (mode: 'client')
import nuxt_plugin_shepherd_6509e1b6 from 'nuxt_plugin_shepherd_6509e1b6' // Source: ../../../plugins/shepherd (mode: 'client')
import nuxt_plugin_googleOptimize_e7b6bda8 from 'nuxt_plugin_googleOptimize_e7b6bda8' // Source: ../../../plugins/googleOptimize (mode: 'client')
import nuxt_plugin_charityConsent_0294f458 from 'nuxt_plugin_charityConsent_0294f458' // Source: ../../../plugins/charityConsent (mode: 'all')
import nuxt_plugin_privacyVaultService_47877095 from 'nuxt_plugin_privacyVaultService_47877095' // Source: ../../../plugins/privacyVaultService (mode: 'all')
import nuxt_plugin_formatDate_c4bd6f8a from 'nuxt_plugin_formatDate_c4bd6f8a' // Source: ../../../plugins/formatDate (mode: 'all')
import nuxt_plugin_formatString_55d86d44 from 'nuxt_plugin_formatString_55d86d44' // Source: ../../../plugins/formatString (mode: 'all')
import nuxt_plugin_select_3c15401c from 'nuxt_plugin_select_3c15401c' // Source: ../../../plugins/select (mode: 'all')
import nuxt_plugin_tooltip_ba49f866 from 'nuxt_plugin_tooltip_ba49f866' // Source: ../../../plugins/tooltip (mode: 'all')
import nuxt_plugin_validate_c33f42e8 from 'nuxt_plugin_validate_c33f42e8' // Source: ../../../plugins/validate (mode: 'all')
import nuxt_plugin_sensitive_e8e29040 from 'nuxt_plugin_sensitive_e8e29040' // Source: ../../../plugins/sensitive (mode: 'all')
import nuxt_plugin_signaturepad_4cb05648 from 'nuxt_plugin_signaturepad_4cb05648' // Source: ../../../plugins/signature-pad (mode: 'client')
import nuxt_plugin_auth_171f72ec from 'nuxt_plugin_auth_171f72ec' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_init_5aefaeb1 from 'nuxt_plugin_init_5aefaeb1' // Source: ../../../plugins/init.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    // https:// github.com/nuxt-modules/i18n/issues/1470
    const i18nHead = this.$nuxtI18nHead ?
    this.$nuxtI18nHead({ addSeoAttributes: true }) :
    { htmlAttrs: [], meta: [], link: [] };
    return {
      title: 'Safewill',
      meta: [
      {
        charset: 'utf-8'
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1'
      },
      {
        hid: 'description',
        name: 'description',
        content: 'Smart wills for modern life.'
      },
      {
        property: 'og:title',
        content: 'Safewill'
      },
      {
        property: 'og:site_name',
        content: 'Safewill'
      },
      {
        property: 'og:description',
        content: 'Smart wills for modern life.'
      },
      {
        property: 'og:url',
        content: 'https://safewill.com/'
      },
      {
        property: 'og:image',
        content: 'https://safewill.com/opengraph.jpg'
      },
      {
        property: 'og:image:width',
        content: '1200'
      },
      {
        property: 'og:image:height',
        content: '630'
      },
      {
        name: 'twitter:card',
        content: 'summary_image_large'
      },
      {
        name: 'twitter:url',
        content: 'https://safewill.com/'
      },
      {
        name: 'twitter:title',
        content: 'Safewill'
      },
      {
        name: 'twitter:description',
        content: 'Smart wills for modern life.'
      },
      {
        name: 'twitter:image',
        content: 'https://safewill.com/opengraph.jpg'
      },
      ...i18nHead.meta],

      script: this.customHeadScripts
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_66572988 === 'function') {
    await nuxt_plugin_sentryserver_66572988(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_009db800 === 'function') {
    await nuxt_plugin_sentryclient_009db800(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_593d6dc4 === 'function') {
    await nuxt_plugin_axios_593d6dc4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_4d023fb1 === 'function') {
    await nuxt_plugin_httpserver_4d023fb1(app.context, inject)
  }

  if (typeof nuxt_plugin_http_f08c47e8 === 'function') {
    await nuxt_plugin_http_f08c47e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_stripemodule_088148e4 === 'function') {
    await nuxt_plugin_stripemodule_088148e4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7921c0f7 === 'function') {
    await nuxt_plugin_pluginutils_7921c0f7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6db5ec82 === 'function') {
    await nuxt_plugin_pluginrouting_6db5ec82(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_23841e2d === 'function') {
    await nuxt_plugin_pluginmain_23841e2d(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_dfaf94e0 === 'function') {
    await nuxt_plugin_apollomodule_dfaf94e0(app.context, inject)
  }

  if (typeof nuxt_plugin_svg4everybody_b33937ba === 'function') {
    await nuxt_plugin_svg4everybody_b33937ba(app.context, inject)
  }

  if (typeof nuxt_plugin_nodelistforeachpolyfill_1ec65051 === 'function') {
    await nuxt_plugin_nodelistforeachpolyfill_1ec65051(app.context, inject)
  }

  if (typeof nuxt_plugin_matchMediaaddListener_24a1a5f4 === 'function') {
    await nuxt_plugin_matchMediaaddListener_24a1a5f4(app.context, inject)
  }

  if (typeof nuxt_plugin_matchmediapolyfill_e33abb9a === 'function') {
    await nuxt_plugin_matchmediapolyfill_e33abb9a(app.context, inject)
  }

  if (typeof nuxt_plugin_es7objectpolyfill_873cf992 === 'function') {
    await nuxt_plugin_es7objectpolyfill_873cf992(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_553e0dcc === 'function') {
    await nuxt_plugin_nuxtmq_553e0dcc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zendeskChat_0986d3fe === 'function') {
    await nuxt_plugin_zendeskChat_0986d3fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_featureFlags_adcaf0b2 === 'function') {
    await nuxt_plugin_featureFlags_adcaf0b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function') {
    await nuxt_plugin_analytics_0ae804d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_downloadPdf_78eb8214 === 'function') {
    await nuxt_plugin_downloadPdf_78eb8214(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroll_3c47dc7a === 'function') {
    await nuxt_plugin_scroll_3c47dc7a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_shepherd_6509e1b6 === 'function') {
    await nuxt_plugin_shepherd_6509e1b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleOptimize_e7b6bda8 === 'function') {
    await nuxt_plugin_googleOptimize_e7b6bda8(app.context, inject)
  }

  if (typeof nuxt_plugin_charityConsent_0294f458 === 'function') {
    await nuxt_plugin_charityConsent_0294f458(app.context, inject)
  }

  if (typeof nuxt_plugin_privacyVaultService_47877095 === 'function') {
    await nuxt_plugin_privacyVaultService_47877095(app.context, inject)
  }

  if (typeof nuxt_plugin_formatDate_c4bd6f8a === 'function') {
    await nuxt_plugin_formatDate_c4bd6f8a(app.context, inject)
  }

  if (typeof nuxt_plugin_formatString_55d86d44 === 'function') {
    await nuxt_plugin_formatString_55d86d44(app.context, inject)
  }

  if (typeof nuxt_plugin_select_3c15401c === 'function') {
    await nuxt_plugin_select_3c15401c(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_ba49f866 === 'function') {
    await nuxt_plugin_tooltip_ba49f866(app.context, inject)
  }

  if (typeof nuxt_plugin_validate_c33f42e8 === 'function') {
    await nuxt_plugin_validate_c33f42e8(app.context, inject)
  }

  if (typeof nuxt_plugin_sensitive_e8e29040 === 'function') {
    await nuxt_plugin_sensitive_e8e29040(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_signaturepad_4cb05648 === 'function') {
    await nuxt_plugin_signaturepad_4cb05648(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_171f72ec === 'function') {
    await nuxt_plugin_auth_171f72ec(app.context, inject)
  }

  if (typeof nuxt_plugin_init_5aefaeb1 === 'function') {
    await nuxt_plugin_init_5aefaeb1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
